import Space from "antd/lib/space";
import styled from "styled-components";

const VerticalSpace = styled(Space)`
  width: 100%;
  display: block;
`;

export { VerticalSpace };
